// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2fl3z","header":"PatientBlock_header__1LiyQ","label":"PatientBlock_label__jVwc-","option":"PatientBlock_option__2bHD8"};